import SearchSelectDropdown from '@/components/search-select-dropdown/search-select-dropdown';
import { learningRegistryAPI } from '@/providers/apis/learning-registry/learning-registry';
import { PERMISSION_CHECK } from '@/utils/constants';
import { Vue, Component, Prop, Watch, Inject, Provide } from 'vue-property-decorator';
import ToolFormLoader from './tool-form-loader';

@Component({
    name: 'data-in-form-tool',
    components: {
        'search-select-dropdown': SearchSelectDropdown,
        'form-render': () => import('@/components/learing-registry/field-render/field-render.vue'),
    },
})

export default class DataInFormTool extends Vue {

    private get formFields() {
        const toolFormLoader = this.toolFormLoader.formData;
        return toolFormLoader[this.activeToolType.key];
    }

    @Provide('validator') public $validator: any = this.$validator;

    public toolFormLoader: any = new ToolFormLoader();

    public dataFromToolOption: any = [
        {
            text: 'Activity Data Stream (ADS) API',
            value: 'ADS',
            key: 'ADS',
        },
        {
            text: 'CSV upload to secure location',
            value: 'CSV',
            key: 'S3_BUCKET',
        },
        {
            text: 'xAPI',
            value: 'xAPI',
            key: 'xAPI',
        },
        {
            text: 'LTI',
            value: 'LTI',
            key: 'LTI',
        },
        {
            text: 'Caliper Analytic',
            value: 'Caliper',
            key: 'CALIPER',
        },
    ];


    @Prop()
    private activeToolData: any;

    private get activeTool() {
        return this.activeToolData;
    }

    private dismissCountDown: number = 0;

    private isLoading: boolean = false;

    private activeToolType = this.dataFromToolOption[1];

    private activeToolValue = this.dataFromToolOption[1].value;

    private toolData: any = {};

    private submitted: boolean = false;

    private permissonCheck = PERMISSION_CHECK;

    public saveToolInfo() {
        this.submitted = true;
        const activeTool = this.activeTool;
        const dataIn: any = {
            isTenantData: !this.$access.isHavingPermisson(this.permissonCheck.createProduct),
            tool_data_in: {},
        };

        this.$validator.validateAll().then((valid: boolean) => {
            const { toolData } = activeTool;
            if (valid && toolData)  {
                this.isLoading = true;
                dataIn.tool_data_in[this.activeToolType.key] = this.toolData;
                learningRegistryAPI.saveToolDataInInfo(toolData.id, dataIn).then((data: any) => {
                    this.activeToolData.toolData.toolDataIn = dataIn.tool_data_in;
                    this.isLoading = false;
                    this.dismissCountDown = 5;
                });
            }
        });
    }

    private created() {
        this.loadDataInContent(true);
    }

    // ----------------------------------------------------------------------
    // Actions

    private onSelectToolType(type: any) {
        const selectedObj = this.dataFromToolOption.filter((item: any) => item.value === type);
        this.activeToolType = selectedObj[0];
        this.submitted = false;
        this.loadDataInContent();
    }

    private loadDataInContent(isLoader = false) {
        const { toolData } = this.activeTool;
        if (toolData && toolData.toolDataIn) {
        if (isLoader) {
            const toolKeys = Object.keys(toolData.toolDataIn);
            toolKeys.forEach((item) => {
               const activeTypeItem = this.dataFromToolOption.find((option: any) => option.key === item);
               if (activeTypeItem) {
                this.activeToolType = activeTypeItem;
               }
            });
        }
        this.toolData = toolData.toolDataIn[this.activeToolType.key] || {};
        }
    }


}
